import request from '@/utils/request2';
export function configList(data, type) {
  console.log(type);
  let url = 'admin/customer/config';
  let data2 = data;
  if (type == 'role') {
    data2 = {
      roleId: data.customerId
    };
    url = 'admin/role/config';
  } else if (type == 'customerRole') {
    data2 = {
      roleId: data.customerId.split(",")[0],
      customerId: data.customerId.split(",")[1]
    };
    url = 'admin/customer/role/config';
  }
  console.log(data2);
  return request.post(url, data2);
}
/**查询配置 */
export function configStore(data, type) {
  let url = 'admin/customer/configStore';
  let data2 = data;
  if (type == 'role') {
    data2 = {
      roleId: data.customerId,
      permissionsData: data.permissionsData
    };
    url = 'admin/role/configStore';
  } else if (type == 'customerRole') {
    data2 = {
      roleId: data.customerId.split(",")[0],
      customerId: data.customerId.split(",")[1],
      permissionsData: data.permissionsData
    };
    url = 'admin/customer/role/configStore';
  }
  return request.post(url, data2);
}